import _objectSpread from "C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var NavbarBrand = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      as = _ref.as,
      props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "as"]);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'navbar-brand');
  var Component = as || (props.href ? 'a' : 'span');
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props, {
    ref: ref,
    className: classNames(className, bsPrefix)
  }));
});
NavbarBrand.displayName = 'NavbarBrand';
export default NavbarBrand;